// extracted by mini-css-extract-plugin
export default {"tabGroup":"_31jaOINV1Lo03jsoJjLW_t","badge":"w33soCGYXUSsihu-ZymGs"};